import React, { useEffect } from 'react'
import { Button } from 'semantic-ui-react'
import { FieldInputProps } from 'react-final-form'

import { CustomAliasInput } from './styles'

interface Props {
  aliases: string[]
  confirm?: () => void
  showBtn: boolean
  showIsInAliases: boolean
  inputProps: FieldInputProps<string, HTMLElement>
  saveIcon?: string
  disabled?: boolean
  saveBtnColor?: 'grey' | 'blue'
  reset?: () => void
}

export const InputWithSave = ({
  aliases = [],
  confirm,
  showBtn,
  showIsInAliases,
  inputProps,
  saveIcon = 'save',
  disabled = false,
  saveBtnColor = 'grey',
  reset,
}: Props) => {
  const inputInAliases =
    aliases.findIndex(
      (alias: string) => alias.toLowerCase() === inputProps.value.trim().toLowerCase()
    ) !== -1 || showIsInAliases

  useEffect(() => {
    if (confirm && inputInAliases) {
      confirm()
    }
  }, [aliases, confirm, inputInAliases])

  return (
    <CustomAliasInput action type="text">
      <input
        disabled={disabled}
        {...inputProps}
        onKeyDown={(e) => {
          if (e.key === 'Escape' && reset) {
            reset()
          }
        }}
      />
      <Button
        basic
        style={{
          visibility: showBtn ? 'visible' : 'hidden',
        }}
        icon={inputInAliases ? 'check circle' : saveIcon}
        color={inputInAliases ? 'green' : saveBtnColor}
        disabled={inputInAliases}
        type="submit"
      />
    </CustomAliasInput>
  )
}
